import { useProdFeatureFlagEnabled } from '~/common/hooks/useProdFeatureFlagEnabled';
import { useAppContext } from '~/services/main/contexts/AppContext';

export const useIsChatEnabled = () => {
  const { isAuthenticated } = useAppContext();
  const isChatEnabled = useProdFeatureFlagEnabled('indigo-chat');

  return isChatEnabled && window.ENVS.environment !== 'e2e' && isAuthenticated;
};

export const useIsDataCoachEnabled = () => {
  const { isAuthenticated } = useAppContext();
  const isDataCoachEnabled = useProdFeatureFlagEnabled('indigo-data-coach');

  return (
    isDataCoachEnabled && window.ENVS.environment !== 'e2e' && isAuthenticated
  );
};
